<template>
  <div class="content">
    <div class="content__wrapper">
      <div class="content__title">
        <h1 class="text-sandybrown">{{ title }}</h1>
      </div>

      <div class="content__espace-container md:flex m-auto md:mt-8">
        <div class="content__espace-item">
          <h3 class="font-bold uppercase text-3xl md:text-nav text-center">
            Portail Doubletrade
          </h3>
          <p class="font-normal italic text-xl md:text-med text-center mt-1">
            Cliquez sur le bouton ci-dessous pour vous identifier et rejoindre
            votre portail DOUBLETRADE
          </p>
          <a target="_blank" href="https://corbet.doubletrade.net"
            ><button class="btn--espace">Rejoindre</button></a
          >
        </div>

        <div class="content__espace-item">
          <h3 class="font-bold uppercase text-3xl md:text-nav text-center">
            Portail de commandes
          </h3>
          <p class="font-normal italic text-xl md:text-med text-center mt-1">
            Cliquez sur le bouton ci-dessous pour vous identifier et rejoindre
            votre portail de commandes
          </p>
          <a target="_blank" href="https://eprint.corbet-com.fr"
            ><button class="btn--espace">Rejoindre</button></a
          >
        </div>
        </div>
      <div class="content__espace-container md:flex m-auto md:mt-8">
        <div class="content__espace-item">
          <h3 class="font-bold uppercase text-3xl md:text-nav text-center">
            BOUTIQUE OLIVET
          </h3>
          <p class="font-normal italic text-xl md:text-med text-center mt-1">
            Cliquez sur le bouton ci-dessous pour acheter des produits autour du patrimoine culturel de la ville d'OLIVET.
          </p>
          <a target="_blank" href="https://olivet.corbet-com.fr"
          ><button class="btn--espace">Rejoindre</button></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'NOS ESPACES'
    }
  }
}
</script>

<style lang="css" scoped>
.content__wrapper {
  padding: 2.5% 2.5% 1.5%;
}

.content__espace-item {
  margin: 10vw 3vw;
  background-color: #ffffff;
  padding: 8vw 3vw;
  box-shadow: 0 3px 6px #00000029;
}

.btn--espace {
  display: block;
  margin: 5.5vw auto auto auto;
  width: 70%;
  background-color: #990d44;
  border-radius: 18px;
  color: #ffffff;
  padding: 2% 3%;
  font-size: 3.5vw;
}

@media screen and (min-width: 768px) {
  .content {
    margin-left: 20%;
  }

  .content__espace-item {
    flex-basis: 45%;
    padding: 5% 5%;
    margin: auto;
    box-shadow: 0 3px 6px #00000029;
  }
  .btn--espace {
    display: block;
    margin: 6% auto auto auto;
    width: 40%;
    background-color: #990d44;
    border-radius: 18px;
    color: #ffffff;
    padding: 2% 3%;
    font-size: 1vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Espaces.vue